import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table9aData = { [key: string]: Table9aRow }
export type Table9aRow = {
  allCrashesKilledTotal: number;
  allCrashesKilledM: number;
  allCrashesKilledF: number;
  allCrashesKilledU: number;
  allCrashesInjuredTotalM: number;
  allCrashesInjuredTotalF: number;
  allCrashesInjuredTotalU: number;
  allCrashesInjuredAM: number;
  allCrashesInjuredAF: number;
  allCrashesInjuredAU: number;
  allCrashesInjuredBM: number;
  allCrashesInjuredBF: number;
  allCrashesInjuredBU: number;
  allCrashesInjuredCM: number;
  allCrashesInjuredCF: number;
  allCrashesInjuredCU: number;
  alcoholRelatedKilledTotal: number;
  alcoholRelatedKilledM: number;
  alcoholRelatedKilledF: number;
  alcoholRelatedKilledU: number;
  alcoholRelatedInjuredTotalM: number;
  alcoholRelatedInjuredTotalF: number;
  alcoholRelatedInjuredTotalU: number;
  alcoholRelatedInjuredAM: number;
  alcoholRelatedInjuredAF: number;
  alcoholRelatedInjuredAU: number;
  alcoholRelatedInjuredBM: number;
  alcoholRelatedInjuredBF: number;
  alcoholRelatedInjuredBU: number;
  alcoholRelatedInjuredCM: number;
  alcoholRelatedInjuredCF: number;
  alcoholRelatedInjuredCU: number;
};
export interface ITable9aClassProps {
  data: Table9aData;
}

interface ITable9aState {
}

const initialState: ITable9aState = {

};

const sortOrder = [
  "14 and younger",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25-34",
  "35-44",
  "45-54",
  "55-64",
  "65-74",
  "75 and older",
  "Age not stated",
  "TOTALS",
];

export default class Table9a extends React.Component<ITable9aClassProps, ITable9aState> {
  public constructor(props: ITable9aClassProps) {
    super(props);
    this.state = initialState;
  };

  public render() {
    return (
      <React.Fragment>
        {!this.props.data && (
          <p>Loading....</p>
        )}
        {this.props.data && (
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: '20%' }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={4} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number" style={{ border: 'none' }}>9a</span>
                    <div style={{ width: '3px', height: '80px', borderLeft: '3px solid black' }} />
                    <span className="header-text">AGE AND SEX OF CASUALTIES</span>
                  </div>
                </th>
                <th colSpan={13} className="border-right-bold">ALL CRASHES</th>
                <th colSpan={13}>ALCOHOL RELATED CRASHES</th>
              </tr>
              <tr>
                <th rowSpan={2} colSpan={4} className="border-right-bold">KILLED</th>
                <th colSpan={9} className="border-right-bold">INJURED</th>
                <th rowSpan={2} colSpan={4} className="border-right-bold">KILLED</th>
                <th colSpan={9}>INJURED</th>
              </tr>
              <tr>
                <th colSpan={3} className="border-right-bold">A *</th>
                <th colSpan={3} className="border-right-bold">B * </th>
                <th colSpan={3} className="border-right-bold">C * </th>
                <th colSpan={3} className="border-right-bold">A *</th>
                <th colSpan={3} className="border-right-bold">B * </th>
                <th colSpan={3}>C * </th>
              </tr>
              <tr>
                <th>Total</th>
                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>
                <th>Total</th>
                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th>U</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key} className={key === 'TOTALS' ? 'border-bold bold-text' : null}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].allCrashesKilledTotal}</td>
                  <td className="numberTotals">{this.props.data[key].allCrashesKilledM}</td>
                  <td className="numberTotals">{this.props.data[key].allCrashesKilledF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].allCrashesKilledU}</td>
                  <td className="numberTotals">{this.props.data[key].allCrashesInjuredAM}</td>
                  <td className="numberTotals">{this.props.data[key].allCrashesInjuredAF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].allCrashesInjuredAU}</td>
                  <td className="numberTotals">{this.props.data[key].allCrashesInjuredBM}</td>
                  <td className="numberTotals">{this.props.data[key].allCrashesInjuredBF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].allCrashesInjuredBU}</td>
                  <td className="numberTotals">{this.props.data[key].allCrashesInjuredCM}</td>
                  <td className="numberTotals">{this.props.data[key].allCrashesInjuredCF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].allCrashesInjuredCU}</td>
                  <td className="numberTotals">{this.props.data[key].alcoholRelatedKilledTotal}</td>
                  <td className="numberTotals">{this.props.data[key].alcoholRelatedKilledM}</td>
                  <td className="numberTotals">{this.props.data[key].alcoholRelatedKilledF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].alcoholRelatedKilledU}</td>
                  <td className="numberTotals">{this.props.data[key].alcoholRelatedInjuredAM}</td>
                  <td className="numberTotals">{this.props.data[key].alcoholRelatedInjuredAF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].alcoholRelatedInjuredAU}</td>
                  <td className="numberTotals">{this.props.data[key].alcoholRelatedInjuredBM}</td>
                  <td className="numberTotals">{this.props.data[key].alcoholRelatedInjuredBF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].alcoholRelatedInjuredBU}</td>
                  <td className="numberTotals">{this.props.data[key].alcoholRelatedInjuredCM}</td>
                  <td className="numberTotals">{this.props.data[key].alcoholRelatedInjuredCF}</td>
                  <td className="numberTotals">{this.props.data[key].alcoholRelatedInjuredCU}</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </React.Fragment>
    );
  }
}
